export default __webpack_public_path__ + "static/media/NelsonRojas.4976ee54.png";